/**
 * SCRIPT INJECTION FOR ORDERING PAGES
 *
 * Poligon Central location:
 * "System" -> Script Injection
 */
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'orderingScriptInjection',
  initialState: null as null | string,
  reducers: {
    setOrderingScriptInjection(state, action: PayloadAction<string | null>) {
      return action.payload || null;
    },
  },
});

export const { setOrderingScriptInjection } = slice.actions;

export default slice.reducer;
